import { Raycaster } from "three";
class Hitscan {
    raycaster;
    lastShotTimestamp;
    constructor() {
        this.raycaster = new Raycaster();
    }
    /**
     * Shoots the gun at entities in a direct line with the camera.
     *
     * Handles rate of fire as well as dealing damage to the entities that were hit.
     * @param entities The entities to check for hits.
     * @param terrain The terrain to check for hits.
     * @param originPosition The position from which the shot originates.
     * @param originDirection The direction of the entity that took the shot.
     * @param fireRate The rate of fire (shots per second).
     * @param baseDamage The base damage per shot.
     * @returns An array of entities that were hit.
     * @todo See if this can be optimized, perhaps by using `raycaster.intersectObjects(scene.children, true)`.
     * @todo Only hit first object. Handle piercing with damage reduction later.
     */
    shoot(entities, terrain, originPosition, originDirection, fireRate, baseDamage) {
        const hitEntities = [];
        if (this.lastShotTimestamp && Date.now() - this.lastShotTimestamp < 1000 / fireRate)
            return false;
        this.lastShotTimestamp = Date.now();
        this.raycaster.set(originPosition, originDirection);
        const terrainIntersection = this.raycaster.intersectObject(terrain.getGroup);
        let closestIntersectionDistance = Infinity;
        let closestHitEntity = null;
        if (terrainIntersection.length > 0) {
            closestIntersectionDistance = originPosition.distanceTo(terrainIntersection[0].point);
        }
        for (const entity of entities) {
            const intersection = this.raycaster.intersectObject(entity.getGroup);
            if (intersection.length > 0) {
                const distance = originPosition.distanceTo(intersection[0].point);
                if (distance < closestIntersectionDistance) {
                    closestIntersectionDistance = distance;
                    closestHitEntity = entity;
                }
            }
        }
        if (closestHitEntity) {
            closestHitEntity.updateHealth(-baseDamage);
            hitEntities.push(closestHitEntity);
        }
        return hitEntities;
    }
}
export { Hitscan };
